<template>
  <div class="review-search">
    <el-select v-model="value" filterable @change="changeSearchKey">
      <el-option
        v-for="item in searchableInfos"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <el-input
      class="right"
      clearable
      v-if="['name', 'telephone'].includes(value)"
      v-model="searchInfo"
      @input="searchData"
    ></el-input>
    <el-select
      class="right"
      v-else-if="value === 'status'"
      v-model="searchInfo"
      filterable
      clearable
      placeholder="请选择"
      style="width: 100%"
      @input="searchData"
    >
      <el-option
        v-for="item in stateOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <div class="icon-search-box" @click="searchData">
      <i class="el-icon-search"></i>
    </div>
  </div>
</template>
<script>
import { searchableInfos, stateOptions } from "./static"
export default {
  name: "review-search",
  data() {
    return {
      searchableInfos,
      stateOptions,
      value: "name",
      searchInfo: "",
      filterKeys: ["name"]
    }
  },
  methods: {
    changeSearchKey(key) {
      this.filterKeys = [key]
      this.searchInfo = ""
    },
    searchData() {
      this.$emit("search", this.searchInfo, this.filterKeys)
    }
  }
}
</script>

<style lang="scss" scoped>
.review-search {
  display: flex;
  width: 280px;
  ::v-deep {
    .el-select {
      width: 190px;
      .el-input.is-focus .el-input__inner {
        border-color: #dcdfe6;
      }
      .el-input__inner {
        border-radius: 4px 0 0 4px;
        border-right: none;
        &:hover,
        &:focus {
          border-color: #dcdfe6;
        }
      }
    }
  }
  .icon-search-box {
    @include flex-center;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px solid #dcdfe6;
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding: 0 12px;
    font-size: 14px;
    cursor: pointer;
  }
  .right {
    ::v-deep {
      .el-input__inner {
        border-radius: unset !important;
      }
      .el-popover__reference-wrapper {
        width: 100%;
        .user-scope-selector-container {
          border-radius: unset !important;
          .value-wrapper {
            min-height: 30px;
          }
        }
      }
    }
  }
}
</style>
